{
  "header": {
    "title": "Plantillas de encuestas",
    "description": "Explora y personaliza plantillas de encuestas predefinidas para obtener rápidamente información valiosa de los empleados"
  },
  "tabs": {
    "chirpeeTemplates": "Plantillas de Chirpee",
    "companyTemplates": "Plantillas de la empresa",
    "myTemplates": "Mis plantillas"
  },
  "searchInput": {
    "placeholder": "Buscar plantillas"
  },
  "sortDropdown": {
    "triggerLabel": "Ordenar por",
    "options": {
      "questionQuantity": "Cantidad de preguntas",
      "fromNewestToOldest": "De más nuevo a más antiguo",
      "fromOldestToNewest": "De más antiguo a más nuevo"
    }
  }
}
